import React, { useState } from 'react';
import { Form, Input, Button, message, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import logo from '../logo.png';
import './LoginPage.css';

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await api.post('/auth/login', values);
      // Save the token and userInfo to localStorage
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userInfo', JSON.stringify(response.data.userInfo || {}));
      
      // Determine redirect path based on role
      const role = response.data.userInfo?.role;
      let redirectPath = '/dashboard';
      if (role === 'CLASS_TEACHER') {
          redirectPath = '/students';
      }
      
      message.success('登录成功');
      navigate(redirectPath);
    } catch (error) {
      console.error('Login error:', error);
      const responseData = error?.response?.data;
      const serverMessage =
        (responseData && typeof responseData === 'object' && responseData.message) ||
        (typeof responseData === 'string' ? responseData : null);
      const networkMessage =
        error?.message === 'Network Error'
          ? '网络错误：无法访问后端接口，请检查API域名/HTTPS/浏览器缓存'
          : null;
      message.error(serverMessage || networkMessage || '登录失败，请检查账号或密码');
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <div className="login-intro">
          <h1>鸿仁云服务</h1>
          <p>专业的智慧校园管理平台</p>
          <p>Smart Campus Management System</p>
        </div>
        
        <div className="login-card">
          <div className="login-card-header">
            <img src={logo} alt="logo" className="login-logo" />
            <div className="login-title">欢迎登录</div>
          </div>
          
          <Form
            name="login"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            size="large"
          >
            <Form.Item
              name="account"
              label="账号"
              rules={[{ required: true, message: '请输入账号!' }]}
            >
              <Input id="login-account" name="account" aria-label="账号" prefix={<UserOutlined />} placeholder="请输入账号" />
            </Form.Item>
            
            <Form.Item
              name="password"
              label="密码"
              rules={[{ required: true, message: '请输入密码!' }]}
            >
              <Input.Password id="login-password" name="password" aria-label="密码" prefix={<LockOutlined />} placeholder="请输入密码" />
            </Form.Item>

            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>记住我</Checkbox>
            </Form.Item>
            <Button type="link" style={{ float: 'right', padding: 0 }} onClick={() => {}}>
              忘记密码
            </Button>

            <Form.Item style={{ marginTop: '24px' }}>
              <Button type="primary" htmlType="submit" loading={loading} className="login-form-button">
                登 录
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
